<div *ngFor="let alert of alerts" class="{{ cssClass(alert) }} alert-mod alert-dismissable">
  <i class="fa {{ iconClass(alert) }}  fa-2x alert-pad" aria-hidden="true"></i>
  <span class="alert-msgbox">{{alert.message}}&nbsp;&nbsp;&nbsp;</span>
  <a class="close" (click)="removeAlert(alert)">&times;</a>
</div>
